import { PatientContactPreferences } from "./contactPreferences";


export class PatientContactPreferencesReq {
  patientId: number;
  isHearingImpaired: boolean;
  isVisuallyImpaired: boolean;
  photoUrl: string;
  patientContactPreferenceDetails: PatientContactPreferences[];
}
